import { createApi } from "@reduxjs/toolkit/query/react";
import { getAxiosInstance } from "../../../api";

const axiosBaseQuery =
  () =>
  async ({ params, endpoint, method, body }) => {
    
    const api = await getAxiosInstance();
    const getParams = (key) => {
    
      if (params?.[key]) {
        return `${key}=${params[key]}&`;
      } else {
        return "";
      }
    };

    try {
      const response = await api[method](
        `${endpoint}?${getParams("sort_by")}&sort_order=${
          params?.sort_order || "desc"
        }&per_page=${params?.per_page || "10"}&${getParams("search")}page=${
          params?.page || 1
        }`,
        body
      );

      return { data: response.data };
    } catch (axiosError) {
      let err = axiosError;

      return {
        data: err?.response?.data || err.message,
      };
    }
  };

export const clusters = createApi({
  reducerPath: "clusterssApi",
  baseQuery: axiosBaseQuery(),
  tagTypes: ["clusters"],
  endpoints: (builder) => ({
    getListData: builder.query({
      query: (values) => ({
        method: "get",
        params: values,
        endpoint: `/v1/admin/cluster/list`,
      }),
      providesTags: ["clusters"],
    }),
    updateTableFieldsData: builder.mutation({
      query: (body) => ({
        method: "post",
        body,
        endpoint: `/v1/admin/table-permission-create`,
      }),

      invalidatesTags: ["clusters"],
    }),
    updateStatus: builder.mutation({
      query: (body) => ({
        method: "post",
        body,
        endpoint: `v1/admin/cluster/change-status`,
      }),

      // invalidatesTags: ["clusters"],
    }),
    getOrderDetailData: builder.query({
      query: (values) => ({
        method: "get",
        params: values,
        endpoint: `/v1/admin/order/detail?order_id=${values.order_id}`,
      }),
      providesTags: ["clusters"],
    }),
    getProductDetailData: builder.query({
      query: (values) => ({
        method: "get",
        params: values,
        endpoint: `/v1/admin/order/product-detail?product_id=${values.product_id}`,
      }),
      providesTags: ["clusters"],
    }),
    getBasicData: builder.query({
      query: () => ({
           method: "get",
           endpoint: `/v1/admin/cluster/basic-data`
      }),
      providesTags: ['clusters'],
 }),
  }),
});

export const { useGetListDataQuery, useUpdateStatusMutation, useUpdateTableFieldsDataMutation, useGetOrderDetailDataQuery, useGetProductDetailDataQuery, useGetBasicDataQuery } = clusters;
